import { clear, el } from '../ui'
import { logOut } from './signin'

// Paused (contract §4 §8) — every route including /api/me refuses a
// suspended or closed business with 403 business_suspended, so this screen
// is a boot-time takeover like "not a Roundly user", never a hash route: no
// nav, nothing else on screen, just the one sentence and a way to sign out.

export function mountPaused(): void {
  const root = document.querySelector<HTMLElement>('#screen')!
  clear(root)
  root.append(el('p', { class: 'empty-note' }, 'This Roundly account is paused. Contact Roundly to turn it back on.'))
  // Roundly's own Log out (the Cloudflare sign-out link this used to be went
  // with the Access sign-in, 28 Sep 2026).
  const signOut = el('button', { type: 'button', class: 'link-button' }, 'Sign out')
  signOut.addEventListener('click', () => void logOut())
  root.append(el('p', {}, signOut))
}

export function pausedOnDataChanged(): void {
  // Nothing to refresh — the whole point of this screen is that no route
  // underneath it can be reached until the business is unpaused.
}
